var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/CommonVideoPlayer/CommonVideoPlayer.jinja"] = require( "front/components/CommonVideoPlayer/CommonVideoPlayer.jinja" );
dependencies["front/utils/sites.jinja"] = require( "front/utils/sites.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/FaqContent/FaqContent.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/FaqContent/FaqContent.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/CommonVideoPlayer/CommonVideoPlayer.jinja", false, "assets/app/front/components/FaqContent/FaqContent.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "CommonVideoPlayer")) {
var t_7 = t_4.CommonVideoPlayer;
} else {
cb(new Error("cannot import 'CommonVideoPlayer'")); return;
}
context.setVariable("CommonVideoPlayer", t_7);
output += "\n\n";
env.getTemplate("front/utils/sites.jinja", false, "assets/app/front/components/FaqContent/FaqContent.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "SITE_SUBMISSIONS")) {
var t_11 = t_8.SITE_SUBMISSIONS;
} else {
cb(new Error("cannot import 'SITE_SUBMISSIONS'")); return;
}
context.setVariable("SITE_SUBMISSIONS", t_11);
output += "\n\n\n\n";
var macro_t_12 = runtime.makeMacro(
[], 
["data", "title"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("title", Object.prototype.hasOwnProperty.call(kwargs, "title") ? kwargs["title"] : "");var t_13 = "";t_13 += "\n    <div class=\"FaqContent ";
t_13 += runtime.suppressValue((env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories")) == 1?"FaqContent--noCategories":""), env.opts.autoescape);
t_13 += "\">\n        <div class=\"FaqContent-faq clearfix\">\n\n            ";
if((env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories")) > 1)) {
t_13 += "\n                <a class=\"FaqContent-faqBack\" href=\"#\">\n                    ";
t_13 += runtime.suppressValue((lineno = 14, colno = 42, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-back","0 0 60 34",runtime.makeKeywordArgs({"caller": (function (){var macro_t_14 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_15 = "";;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
return macro_t_14;})()})])), env.opts.autoescape);
t_13 += "\n                    <span>Back</span>\n                </a>\n            ";
;
}
t_13 += "\n\n            <h2>";
t_13 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
t_13 += "</h2>\n\n            <div class=\"FaqContent-faqWrapper\">\n\n                <div class=\"FaqContent-faqLeft\">\n                    <ul>\n                        ";
frame = frame.push();
var t_18 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories");
if(t_18) {t_18 = runtime.fromIterator(t_18);
var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("category", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
t_13 += "<li class=\"FaqContent-faqCategory ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0)) {
t_13 += "FaqContent-faqCategory--active";
;
}
t_13 += "\"  data-slug=\"";
t_13 += runtime.suppressValue((runtime.memberLookup((t_19),"slug")?runtime.memberLookup((t_19),"slug"):"all"), env.opts.autoescape);
t_13 += "\">\n                                <a href=\"#";
t_13 += runtime.suppressValue((runtime.memberLookup((t_19),"slug")?runtime.memberLookup((t_19),"slug"):"all"), env.opts.autoescape);
t_13 += "\">\n                                    ";
t_13 += runtime.suppressValue(runtime.memberLookup((t_19),"title"), env.opts.autoescape);
t_13 += "\n                                    <div class=\"FaqContent-faqCategoryArrow\">\n                                        ";
t_13 += runtime.suppressValue((lineno = 30, colno = 62, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_20 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_21 = "";;
frame = frame.pop();
return new runtime.SafeString(t_21);
});
return macro_t_20;})()})])), env.opts.autoescape);
t_13 += "\n                                    </div>\n                                </a>\n                            </li>\n                        ";
;
}
}
frame = frame.pop();
t_13 += "\n                    </ul>\n                </div>\n\n                <div class=\"FaqContent-faqRight\">\n                    ";
frame = frame.push();
var t_24 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"categories");
if(t_24) {t_24 = runtime.fromIterator(t_24);
var t_23 = t_24.length;
for(var t_22=0; t_22 < t_24.length; t_22++) {
var t_25 = t_24[t_22];
frame.set("category", t_25);
frame.set("loop.index", t_22 + 1);
frame.set("loop.index0", t_22);
frame.set("loop.revindex", t_23 - t_22);
frame.set("loop.revindex0", t_23 - t_22 - 1);
frame.set("loop.first", t_22 === 0);
frame.set("loop.last", t_22 === t_23 - 1);
frame.set("loop.length", t_23);
t_13 += "<div class=\"FaqContent-faqRightCategories ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0)) {
t_13 += "FaqContent-faqRightCategories--active";
;
}
t_13 += "\" data-slug=\"";
t_13 += runtime.suppressValue((runtime.memberLookup((t_25),"slug")?runtime.memberLookup((t_25),"slug"):"all"), env.opts.autoescape);
t_13 += "\">\n                            <ul>\n                                ";
frame = frame.push();
var t_28 = runtime.memberLookup((t_25),"questions");
if(t_28) {t_28 = runtime.fromIterator(t_28);
var t_27 = t_28.length;
for(var t_26=0; t_26 < t_28.length; t_26++) {
var t_29 = t_28[t_26];
frame.set("question", t_29);
frame.set("loop.index", t_26 + 1);
frame.set("loop.index0", t_26);
frame.set("loop.revindex", t_27 - t_26);
frame.set("loop.revindex0", t_27 - t_26 - 1);
frame.set("loop.first", t_26 === 0);
frame.set("loop.last", t_26 === t_27 - 1);
frame.set("loop.length", t_27);
t_13 += "<li class=\"FaqContent-faqQuestion\" data-slug=\"";
t_13 += runtime.suppressValue(runtime.memberLookup((t_29),"slug"), env.opts.autoescape);
t_13 += "\">\n                                        ";
if((runtime.memberLookup((t_25),"isUrl"))) {
t_13 += "\n                                            <a class=\"FaqContent-faqQuestionLink\" href=\"";
t_13 += runtime.suppressValue(runtime.memberLookup((t_29),"question"), env.opts.autoescape);
t_13 += "\">";
t_13 += runtime.suppressValue(runtime.memberLookup((t_29),"question"), env.opts.autoescape);
t_13 += "</a>\n                                        ";
;
}
else {
t_13 += "\n                                            <a class=\"FaqContent-faqQuestionText\" href=\"#";
t_13 += runtime.suppressValue((runtime.memberLookup((t_25),"slug")?runtime.memberLookup((t_25),"slug"):"all"), env.opts.autoescape);
t_13 += "/";
t_13 += runtime.suppressValue(runtime.memberLookup((t_29),"slug"), env.opts.autoescape);
t_13 += "\">";
t_13 += runtime.suppressValue(runtime.memberLookup((t_29),"question"), env.opts.autoescape);
t_13 += "</a>\n                                            <div class=\"FaqContent-faqQuestionClose\"></div>\n                                            <div class=\"FaqContent-faqQuestionRolled\">\n                                                <div class=\"FaqContent-faqQuestionAnswer TextFormatting\">";
t_13 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_29),"answerRendered")), env.opts.autoescape);
t_13 += "</div>\n                                                ";
if(runtime.memberLookup((t_29),"attachments")) {
t_13 += "\n                                                    ";
t_13 += runtime.suppressValue((lineno = 52, colno = 68, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "AttachmentsList"), "AttachmentsList", context, [runtime.memberLookup((t_29),"attachments")])), env.opts.autoescape);
t_13 += "\n                                                ";
;
}
t_13 += "\n                                            </div>\n                                        ";
;
}
t_13 += "\n                                    </li>\n                                ";
;
}
}
frame = frame.pop();
t_13 += "\n                            </ul>\n                        </div>\n                    ";
;
}
}
frame = frame.pop();
t_13 += "\n                </div>\n            </div>\n\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_13);
});
context.addExport("FaqContent");
context.setVariable("FaqContent", macro_t_12);
output += "\n\n\n";
var macro_t_30 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_31 = "";t_31 += "\n    <ul class=\"FaqContent-attachmentsList\">\n        ";
frame = frame.push();
var t_34 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_34) {t_34 = runtime.fromIterator(t_34);
var t_33 = t_34.length;
for(var t_32=0; t_32 < t_34.length; t_32++) {
var t_35 = t_34[t_32];
frame.set("item", t_35);
frame.set("loop.index", t_32 + 1);
frame.set("loop.index0", t_32);
frame.set("loop.revindex", t_33 - t_32);
frame.set("loop.revindex0", t_33 - t_32 - 1);
frame.set("loop.first", t_32 === 0);
frame.set("loop.last", t_32 === t_33 - 1);
frame.set("loop.length", t_33);
t_31 += "<li class=\"FaqContent-attachmentsListItem ";
if((runtime.memberLookup((t_35),"file"))) {
t_31 += "FaqContent-attachmentsListItem--only-arrow";
;
}
t_31 += "\">\n                ";
if((runtime.memberLookup((t_35),"file"))) {
t_31 += "\n                    <a class=\"FaqContent-attachmentsListItemLink\"target=\"_blank\" href=\"";
t_31 += runtime.suppressValue(runtime.memberLookup((t_35),"file"), env.opts.autoescape);
t_31 += "\">\n                        <div class=\"FaqContent-attachmentsListItemTitle\">";
t_31 += runtime.suppressValue(runtime.memberLookup((t_35),"title"), env.opts.autoescape);
t_31 += "</div>\n                        <div class=\"FaqContent-attachmentsListItemArrow\">\n                            ";
t_31 += runtime.suppressValue((lineno = 77, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_36 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_37 = "";;
frame = frame.pop();
return new runtime.SafeString(t_37);
});
return macro_t_36;})()})])), env.opts.autoescape);
t_31 += "\n                        </div>\n                    </a>\n                ";
;
}
else {
if(runtime.memberLookup((t_35),"embed")) {
t_31 += "\n                    <div class=\"FaqContent-attachmentsListItemVideo\">\n                        ";
t_31 += runtime.suppressValue((lineno = 82, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonVideoPlayer"), "CommonVideoPlayer", context, [runtime.makeKeywordArgs({"data": {"provider": runtime.memberLookup((t_35),"provider"),"code": runtime.memberLookup((t_35),"embed")}})])), env.opts.autoescape);
t_31 += "\n                    </div>\n                ";
;
}
;
}
t_31 += "\n            </li>\n        ";
;
}
}
frame = frame.pop();
t_31 += "\n    </ul>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_31);
});
context.addExport("AttachmentsList");
context.setVariable("AttachmentsList", macro_t_30);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/FaqContent/FaqContent.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/FaqContent/FaqContent.jinja
// module id = 491
// module chunks = 0